import React, { useState }    from 'react'
import AppLayout              from '@/Layouts/AppLayout'
import OrganizationLayout     from '@/Layouts/OrganizationLayout'
import { Inertia }            from "@inertiajs/inertia";
import { EditQuestion }       from "@/Components/Questions/EditQuestion";
import LayoutIcon             from "@/Components/LayoutIcon";
import { Teams as TeamsIcon } from "@/Icons";
import { usePage }            from "@inertiajs/inertia-react";
import { ROLE_ID }            from "@/Enums/roles";
import { toast }              from "react-toastify";
import { X }                  from "react-feather";

export default function Edit({ question }) {

  return (
    <EditQuestion question={question.data} />
  )
}

export const QuestionRemovalButton = ({ question, team }) => {
  const user    = usePage().props?.auth?.user?.data || {}
  const isOwner = user?.organization_role_id === ROLE_ID.OWNER;

  const [showModal, setShowModal] = useState(false);

  const handleDelete = () => {
    const id = toast.loading("Please wait...");

    Inertia.delete(route('team.question.detach', { question: question, team: team.id, shouldRedirect: 1 }), {
      onSuccess: () => {
        toast.update(id, { render: "The question has been removed from your team!", type: "success", isLoading: false, autoClose: 5000 });
      },
      onError: (error) => {
        toast.update(id, { render: "Something went wrong when removing the question", type: "error", isLoading: false, autoClose: 5000 });
      },
    });
  }

  if (!isOwner) return null;

  return (
    <>
      <button className="underline hover:no-underline text-blue" onClick={() => setShowModal(true)}>Delete question</button>
      {showModal &&
        <div className="fixed top-0 left-0 z-20 flex flex-col justify-center w-full h-full bg-black bg-opacity-50">
          <div className="absolute top-0 left-0 w-full h-full" onClick={() => setShowModal(false)}/>
          <div className="relative w-full max-w-2xl p-8 mx-auto align-middle bg-white md:p-16">
            <X className="absolute top-0 right-0 w-12 h-12 p-2 cursor-pointer" onClick={() => setShowModal(false)} />
            <h3 className="mb-3 text-xl font-semibold">Are you sure that you want to continue?</h3>
            <p>Deleting this question will permanently remove it from your team and you will not be able to restore it.</p>

            <div className="flex justify-end w-full pt-8 mt-5 border-t">
              <a className="py-2 underline cursor-pointer text-blue" onClick={() => setShowModal(false)}>
                Cancel
              </a>

              <button
                className="self-end ml-3 btn"
                onClick={handleDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      }
    </>
  )
}

Edit.layout = page => {

  const team = page.props?.team?.data;
  const question = page.props?.question?.data;

  const backAction = () => {
    const backUrl = route('team.overview', team);
    const previousUrl = page.props?.previous_url;
    const [previousPath] = previousUrl.split('?');

    if (backUrl === previousPath && window.history.length > 1) {
      window.history.back();
    } else {
      Inertia.visit(backUrl);
    }
  }

  return (
    <AppLayout title={`Edit activity ${question?.title}`}>
      <OrganizationLayout
        header="Edit activity"
        preamble={question?.title || 'No question found'}
        backAction={{ label: 'Back', callback: backAction }}
        icon={<LayoutIcon><TeamsIcon size={40} className="text-black"/></LayoutIcon>}
      >{page}</OrganizationLayout>
    </AppLayout>
  )
}
